import React, { useState, useEffect } from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import config from "../../config";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";
import Socket from "../../components/Socket";
import BarcodeReader from 'react-barcode-reader'

// pages
import Dashboard from "../../pages/dashboard";
import User from "../../pages/user";
import Partner from "../../pages/partner/Partner";
import Membership from "../../pages/membership/Membership";
import Sauna from "../../pages/sauna/Sauna";
import Settings from "../../pages/settings";
import AddProduct from "../../pages/products/addProduct";
import productEntry from "../../pages/products/productEntry";
import productOutlet from "../../pages/products/productOutlet";
import UserInfo from "../../pages/user/components/userInfo";
import PartnerInfo from "../../pages/partner/components/partnerInfo";
import MembershipInfo from "../../pages/membership/components/membershipInfo";
import Ventas from "../../pages/punto de venta/Ventas";

import AddUser from "../../pages/user/components/addUser";
import AddPartner from "../../pages/partner/components/addPartner";
import AddGender from "../../pages/settings/components/AddGender";
import AddPartnerType from "../../pages/settings/components/AddPartnerType";
import AddMembership from "../../pages/membership/components/AddMembership";
import AddService from "../../pages/settings/components/AddService";
import AddMembershipType from "../../pages/settings/components/AddMembershipType";
import AddUserType from "../../pages/settings/components/AddUserType";
import AddJob from "../../pages/settings/components/AddJob";
import AddPaymentMethod from "../../pages/settings/components/AddPaymentMethod";
import AddPaymentPeriod from "../../pages/settings/components/AddPaymentPeriod";
import AddGroupTypePartner from "../../pages/settings/components/AddGroupTypePartner";
import PayMembership from "../../pages/partner/payMembership";
import AddCategoryProduct from "../../pages/settings/components/AddCategoryProduct";
import AddSaleUnit from "../../pages/settings/components/AddSaleUnit";
import AddEstablishment from "../../pages/settings/components/AddEstablishment";
import ServiceInfo from "../../pages/settings/components/ServiceInfo";
import AddSupplier from "../../pages/settings/components/AddSupplier";
import AddPaymentConcept from "../../pages/settings/components/AddPaymentConcept";
import ReportCash from "../../pages/cash/ReportCash"
import CashOut from "../../pages/cash/CashOut"
import OtherSalse from "../../pages/cash/OtherSales"
import BoxEntry from "../../pages/cash/BoxEntry"
import BoxEgress from "../../pages/cash/BoxEgress"
import PartnerInfoOneDay from "../../pages/partner/components/partnerInfoOneDay";
import Stock from "../../pages/products/stock";
import ProductInfo from "../../pages/products/productInfo";
import InfoPaymentConcept from "../../pages/settings/components/InfoPaymentConcept";
import AddOtherConcept from "../../pages/settings/components/AddOtherConcept"
import InfoOtherConcept from "../../pages/settings/components/InfoOtherConcept"
import EgressReport from "../../pages/reports/EgressReport";
import EntryReport from "../../pages/reports/EntryReport";
import CashOutReport from "../../pages/reports/CashOutReport";
import ProductsReport from "../../pages/reports/ProductsReport";
import PartnerReport from "../../pages/reports/PartnerReport";

// context
import { useLayoutState } from "../../context/LayoutContext";

function Layout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  //local
  var [user, setUserType] = useState(0);
  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);

  useEffect(function () {
    var idToken = localStorage.getItem("id_token");
    setUserType(idToken);
  });

  const handleScan = (data) => {
    const newBody = {
      qrCode: data
    };

    fetch(baseUrl + "postOpenByQrCode",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(newBody)
      }).then(response => response.json())
      .then(data => { })
      .catch(error => { });
  }

  const handleError = (err) => { }

  return (
    <div className={classes.root}>
      <>
        <Socket />
        <Header history={props.history} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <div>
            <BarcodeReader
              onError={handleError}
              onScan={handleScan}
              timeBeforeScanTest={86400}
            />
          </div>

          <Switch>
            <Route path="/app/dashboard" component={Dashboard} />
            {user == 1 ? <Route path="/app/user" component={User} /> : null}
            <Route path="/app/partner" component={Partner} />
            <Route path="/app/membership" component={Membership} />
            <Route path="/app/sauna" component={Sauna} />
            {user == 1 ? <Route
              exact
              path="/app/compras"
              render={() => <Redirect to="/app/compras/inventario" />}
            /> : null}
            {user == 1 ? <Route path="/app/compras/product" component={Stock} /> : null}
            {user == 1 ? <Route path="/app/compras/productEntry" component={productEntry} /> : null}
            {user == 1 ? <Route path="/app/compras/productOutlet" component={productOutlet} /> : null}
            <Route path="/app/ventas" component={Ventas} />
            {user == 1 ? <Route path="/app/settings" component={Settings} /> : null}
            <Route path="/app/addUser" component={AddUser} />
            <Route path="/app/addPartner" component={AddPartner} />
            <Route path="/app/addGender" component={AddGender} />
            <Route path="/app/addPartnerType" component={AddPartnerType} />
            <Route path="/app/addMembership" component={AddMembership} />
            <Route path="/app/addService" component={AddService} />
            <Route path="/app/addMembershipType" component={AddMembershipType} />
            <Route path="/app/addUserType" component={AddUserType} />
            <Route path="/app/addJob" component={AddJob} />
            <Route path="/app/addPaymentMethod" component={AddPaymentMethod} />
            <Route path="/app/addPaymentPeriod" component={AddPaymentPeriod} />
            <Route path="/app/addGroupTypePartner" component={AddGroupTypePartner} />
            <Route path="/app/userInfo" component={UserInfo} />
            <Route path="/app/partnerInfo" component={PartnerInfo} />
            <Route path="/app/membershipInfo" component={MembershipInfo} />
            <Route path="/app/payMembership" component={PayMembership} />
            <Route path="/app/addProduct" component={AddProduct} />
            <Route path="/app/addCategoryProduct" component={AddCategoryProduct} />
            <Route path="/app/addSaleUnit" component={AddSaleUnit} />
            <Route path="/app/addEstablishment" component={AddEstablishment} />
            <Route path="/app/serviceInfo" component={ServiceInfo} />
            <Route path="/app/addSupplier" component={AddSupplier} />
            <Route path="/app/addPaymentConcept" component={AddPaymentConcept} />
            <Route path="/app/reportCash" component={ReportCash} />
            <Route path="/app/cashOut" component={CashOut} />
            <Route path="/app/box/otherSalse" component={OtherSalse} />
            <Route path="/app/box/entry" component={BoxEntry} />
            <Route path="/app/box/egress" component={BoxEgress} />
            <Route path="/app/partnerInfoOneDay" component={PartnerInfoOneDay} />
            <Route path="/app/productInfo" component={ProductInfo} />
            <Route path="/app/infoPaymentConcept" component={InfoPaymentConcept} />
            <Route path="/app/addOtherConcept" component={AddOtherConcept} />
            <Route path="/app/infoOtherConcept" component={InfoOtherConcept} />
            <Route path="/app/report/egress" component={EgressReport} />
            <Route path="/app/report/entry" component={EntryReport} />
            <Route path="/app/report/cashout" component={CashOutReport} />
            <Route path="/app/report/products" component={ProductsReport} />
            <Route path="/app/report/partners" component={PartnerReport} />
          </Switch>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
